class DetailsModal extends HTMLElement {
  constructor() {
    super();

    // SKIP initialization for mobile search - it has its own handler
    if (this.classList.contains('mobile-search-only')) {
      return;
    }

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.openingEvent = null; // Track the event that opened the modal

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    // Safely bind close button if it exists
    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation(); // Prevent bubbling that could immediately close the modal
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Ignore the same click event that opened the modal
    if (this.openingEvent && event.timeStamp === this.openingEvent.timeStamp) {
      return;
    }

    // Ignore clicks on the summary toggle (it has its own handler)
    if (this.summaryToggle && this.summaryToggle.contains(event.target)) {
      return;
    }

    // Close if clicked outside the modal content
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.openingEvent = event; // Store the opening event
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);

    // Delay adding the body click listener to avoid the opening click triggering close
    requestAnimationFrame(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    });

    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    this.openingEvent = null; // Clear the opening event
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
